export default function isHexColor(value: string): boolean {
  const hexRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;

  if (hexRegex.test(value)) return true;

  return false;
}
